'use client';

import { useSettledMainnetGateStore } from '@/stores/settled-mainnet-gate';

/**
 * Returns whether the `mainnet_enabled` gate is on, re-rendering when it settles.
 *
 * @remarks
 * Reads the last settled value `<MainnetGateMirror>` stored (DevToolkit
 * override or Statsig), the same value `useActiveNetwork` clamps on. It is
 * `false` until the gate first settles and holds through Statsig loading and
 * identity updates. Read the gate through this hook, not through `checkGate`:
 * a render-time `checkGate` call runs before Statsig loads, and React Compiler
 * keeps its `false` for the component's lifetime. `useSwitchNetwork` reads it
 * too, so a switch to mainnet uses the value that the page shows.
 *
 * @example
 * ```ts
 * const mainnetEnabled = useMainnetEnabled();
 * const destination = resolveAuthRedirect(path, userNetwork, mainnetEnabled);
 * ```
 */
export function useMainnetEnabled() {
  return useSettledMainnetGateStore(_temp) === true;
}
function _temp(s) {
  return s.settled;
}